

module.exports = __webpack_require__.stylable.create(
    "Picker113184335",
    {"classes":{"root":"Picker113184335__root","value":"Picker113184335__value","arrow":"Picker113184335__arrow"},"vars":{},"stVars":{"DefaultMainColor":"\"color(color-5)\"","DefaultFontStyle":"\"{theme: 'Body-M', size: '20px', lineHeight: '28px'}\"","MainColor":"--overridable","FontStyle":"--overridable","CurrentMainColor":"\"color(fallback(--overridable, color(color-5)))\"","CurrentFontStyle":"\"fallback(--overridable, font({theme: 'Body-M', size: '20px', lineHeight: '28px'}))\""},"keyframes":{}},
    "",
    4,
    "Picker113184335",
    null
);
